import apiClient from './client';

// Region forecast for scheduling (server-cached; module-cached here too)
export interface DayForecast {
  date: string;
  t_max: number;
  t_min: number;
  precip_mm: number;
  precip_prob: number;
  snow_cm: number;
  wind_kmh: number;
  code: number;
  risk: 'none' | 'caution' | 'high';
}

let mem: { at: number; days: DayForecast[] } | null = null;

export async function getForecast(): Promise<DayForecast[]> {
  if (mem && Date.now() - mem.at < 30 * 60 * 1000) return mem.days;
  const r = await apiClient.get('/weather');
  const days = (r.data.data ?? []) as DayForecast[];
  mem = { at: Date.now(), days };
  return days;
}

// WMO weather codes → a material icon
export const weatherIcon = (code: number): string => {
  if (code === 0) return 'sunny';
  if (code <= 2) return 'partly_cloudy_day';
  if (code === 3) return 'cloud';
  if (code <= 48) return 'foggy';
  if (code <= 67 || (code >= 80 && code <= 82)) return 'rainy';
  if (code <= 77 || (code >= 85 && code <= 86)) return 'weather_snowy';
  if (code >= 95) return 'thunderstorm';
  return 'cloud';
};
